export const portfolioData = [
  {
    id: 2,
    title: "Generic Portfolio Site",
    description:
      "A generic portfolio site built in mobile first, contains 3 different view ports for various screen sizes",
    techUsed: "HTML, CSS",
    image: "./port_proj_2.jpg",
  },

  {
    id: 3,
    title: "Registration Form",
    description:
      "Registration form that operates in two view port screen sizes, no backend to capture form submission",
    techUsed: "HTML, CSS",
    image: "./port_proj_3.jpg",
  },

  {
    id: 4,
    title: "Utilizing SASS",
    description:
      "Mobile responsive site using CSS preprocessor SASS, articulating flex box capabilities",
    techUsed: "HTML, CSS, SASS",
    image: "./port_proj_4.jpg",
  },

  {
    id: 6,
    title: "Word Guessing Game",
    description: "Word guessing game, using JavaScript for DOM manipulation",
    techUsed: "HTML, CSS, JavaScript",
    image: "./port_proj_6.jpg",
  },

  {
    id: 7,
    title: "Social Traffic App",
    description:
      "Traffic charting app, includes chart.JS library and all vanilla CSS styling (Mobile Version)",
    techUsed: "HTML, CSS, JavaScript",
    image: "./port_proj_7.jpg",
  },
];
